import React from "react";
import { useLocation } from "react-router-dom";
import "../App.css";
import Header from "../components/layout/header/Header";
import HeroSection from "../components/layout/hero/HeroSection";
import Footer from "../components/layout/footer/Footer";
import ProcessSteps from "../components/layout/processSteps/ProcessSteps";
import LaunchSection from "../components/layout/launch/LaunchSection";
import PricingSection from "../components/layout/pricing/PricingSection";
import QASection from "../components/layout/qa/QASection";
import AuditSection from "../components/layout/audit/AuditSection";
import { Helmet } from "react-helmet-async";

const pageTitle = "AIGIO - Digital Presence Insights & Strategy";
const pageDescription = "Transform your digital presence with our comprehensive audit and optimization services.";

const LandingPage: React.FC = () => {
  const location = useLocation();

  React.useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    // Wait for layout so the target section exists before scrolling.
    requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    });
  }, [location.hash, location.key]);

  return (
    <div className="App">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <Header />
      <div className="landing-page">
        <HeroSection />
        <ProcessSteps />
      </div>
      <div className="landing-page-secondary">
        <LaunchSection />
        <AuditSection />
        <div className="section-divider" aria-hidden="true" />
        <PricingSection />
        <div className="section-divider" aria-hidden="true" />
      </div>
      <QASection />
      <Footer />
    </div>
  );
};

export default LandingPage;
